import React, { LazyExoticComponent, lazy } from 'react'
import DetalleAutorizacion from '../pages/autorizaciones/components/detalleAutorizacion/DetalleAutorizacion'
import AgregarEditarSitio from '../../src/pages/sitios/AgregarEditarSitio'
import { AgregarEditarAutorizacion } from '../../src/pages/autorizaciones/AgregarEditarAutorizacion'
import { Roles } from '../utils/Roles'

type JSXComponent = () => React.JSX.Element

interface Ruta {
  nombre: string
  icono: string
  path: string
  to: string
  Componente: LazyExoticComponent<JSXComponent> | JSXComponent
  children?: RutaHija[]
  permisos: string[]
}

interface RutaHija {
  to: string
  path: string
  Componente: LazyExoticComponent<JSXComponent> | JSXComponent
}

const InicioPagina = lazy(
  () => import(/* webpackChunkName: "Home" */ '../pages/inicio/InicioPagina')
)

const AutorizacionPagina = lazy(
  () =>
    import(/* webpackChunkName: "Authorization" */ '../pages/autorizaciones/AutorizacionesPagina')
)
const CalendarioPagina = lazy(
  () => import(/* webpackChunkName: "Calendar" */ '../pages/calendario/CalendarioPagina')
)
const SitiosPagina = lazy(
  () => import(/* webpackChunkName: "Sites" */ '../pages/sitios/SitiosPagina')
)
const NotificacionesPagina = lazy(
  () =>
    import(/* webpackChunkName: "Notifications" */ '../pages/notificaciones/NotificacionesPagina')
)
const UsuariosPagina = lazy(
  () => import(/* webpackChunkName: "userProfile" */ '../pages/usuarios/UsuariosPagina')
)
const TareasPagina = lazy(
  () => import(/* webpackChunkName: "Tasks" */ '../pages/tareas/TareasPagina')
)
const CatalogosPagina = lazy(
  () => import(/* webpackChunkName: "Catalogs" */ '../pages/catalogos/CatalogosPagina')
)

export const routes: Ruta[] = [
  /**
   * Catalogo central de navegacion privada.
   *
   * Cada entrada alimenta al router y al menu lateral. El arreglo `permisos`
   * controla visibilidad de ruta y menu; las acciones internas pueden requerir
   * roles mas especificos con `ComponentePrivado`.
   */
  {
    nombre: 'Inicio',
    icono: '/svg/home.svg',
    to: '/inicio',
    path: 'inicio',
    Componente: InicioPagina,
    permisos: [],
  },
  {
    nombre: 'Notificaciones',
    icono: '/svg/notifications.svg',
    to: '/notificaciones',
    path: 'notificaciones',
    Componente: NotificacionesPagina,
    permisos: [],
  },
  {
    nombre: 'Calendario',
    icono: '/svg/calendar.svg',
    to: '/calendario',
    path: 'calendario',
    Componente: CalendarioPagina,
    permisos: [Roles.roleCalendarioCrear, Roles.roleCalendarioLectura],
  },
  {
    nombre: 'Sitios',
    icono: '/svg/location.svg',
    to: '/sitios',
    path: 'sitios',
    Componente: SitiosPagina,
    children: [
      {
        to: '/sitios/agregar',
        path: 'sitios/agregar',
        Componente: AgregarEditarSitio,
      },
      {
        to: '/sitios/editar/:idSitio',
        path: '/sitios/editar/:idSitio',
        Componente: AgregarEditarSitio,
      },
    ],
    permisos: [Roles.roleSitiosCrear, Roles.roleSitiosLectura],
  },
  {
    nombre: 'Autorizaciones',
    icono: '/svg/authorization.svg',
    to: '/autorizaciones',
    path: 'autorizaciones',
    Componente: AutorizacionPagina,
    children: [
      {
        to: '/autorizaciones/agregar',
        path: 'autorizaciones/agregar',
        Componente: AgregarEditarAutorizacion,
      },
      {
        to: '/autorizaciones/detalle/:idAutorizacion',
        path: 'autorizaciones/detalle/:idAutorizacion',
        Componente: DetalleAutorizacion,
      },
      {
        to: '/autorizaciones/editar/:idAutorizacion',
        path: '/autorizaciones/editar/:idAutorizacion',
        Componente: AgregarEditarAutorizacion,
      },
    ],
    permisos: [Roles.roleAutorizacionesCrear, Roles.roleAutorizacionesLectura],
  },
  {
    nombre: 'Tareas',
    icono: '/svg/tasks.svg',
    to: '/tareas',
    path: 'tareas',
    Componente: TareasPagina,
    permisos: [Roles.roleTareasCrear, Roles.roleTareasLectura],
  },
  {
    nombre: 'Usuarios',
    icono: '/svg/user.svg',
    to: '/usuarios',
    path: 'usuarios',
    Componente: UsuariosPagina,
    permisos: [Roles.roleUsuariosCrear, Roles.roleUsuariosLectura],
  },
  {
    nombre: 'Catálogos',
    icono: '/svg/catalog.svg',
    to: '/catalogos',
    path: 'catalogos',
    Componente: CatalogosPagina,
    permisos: [Roles.roleCatalogosCrear, Roles.roleCatalogosLectura],
  },
]
